/**
 * Created by fworld on 2019/9/20.
 */
import request from '@/util/request'

/**
 * 企业产品列表
 * @returns {AxiosPromise}
 */
export const enterpriseUnion = (params) => {
    return request({
        url: `/api/v1/account/enterprise/union`,
        method: 'get',
        params
    })
}

export const enterpriseCreate = (data) => {
    return request({
        url: `/api/v1/account/enterprise/register`,
        method: 'post',
        data
    })
}

export const enterpriseList = (params) => {
    return request({
        url: `/api/v1/account/enterprise/list`,
        method: 'get',
        params
    })
}


export const enterpriseAllName = () => {
    return request({
        url: `/api/v1/account/enterprise/allName`,
        method: 'get',
    })
}

export function enterpriseCtrl(params) {
    return request({
        url: `/api/v1/account/enterprise/ctrl`,
        method: `get`,
        params
    })
}

export function enterpriseDelete(params) {
  return request({
    url: `/api/v1/account/enterprise/delete`,
    method: 'GET',
    params
  })
}
